import i18next from 'i18next';

/**
 * Actions of the order form, hosted by the `...` button of the selectors row. There are no
 * checkboxes on the table — every catalog line is already displayed — so the actions never depend on
 * a selection: the export always carries the whole order, and the deletion is dropped from the menu
 * without the draft deletion right.
 *
 * @param {Object} params
 * @param {boolean} params.canDeleteDraft - Whether the user can delete a draft order
 * @param {boolean} params.isCreation - Whether the order does not exist server-side yet
 * @param {Function} params.onExport - Export handler
 * @param {Function} params.onDelete - Deletion handler
 *
 * @returns {Array<Object>} The Button dropdown actions
 */
export const getExternalOrderFormActions = ({ canDeleteDraft, isCreation, onExport, onDelete }) => {
  const actions = [
    {
      id: 'action-export-order',
      label: i18next.t('EXTERNAL_ORDERS.FORM.EXPORT_ORDER'),
      icon: '/images/inpulse/file-download-black-small.svg',
      handleClick: onExport,
    },
  ];

  // Nothing to delete as long as the draft has not been saved once.
  if (canDeleteDraft && !isCreation) {
    actions.push({
      id: 'action-delete-order',
      label: i18next.t('EXTERNAL_ORDERS.LIST.DELETE_ORDER'),
      icon: '/images/inpulse/trash-black-small.svg',
      handleClick: onDelete,
    });
  }

  return actions;
};
